// eslint-disable-next-line max-len

import { createSelector, createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ServiceGroup } from '@quorum/models/xs-resource';

export interface AcceptedServicesState extends EntityState<ServiceGroup> {}

export const acceptedServicesAdapter: EntityAdapter<ServiceGroup> = createEntityAdapter<ServiceGroup>({
  selectId: (serviceGroup: ServiceGroup) => serviceGroup.id
});

export const initialState: AcceptedServicesState = acceptedServicesAdapter.getInitialState({});
export const AcceptedServicesFeatureSelector = createFeatureSelector<any>('vehicleMaintenance');
export const acceptedServiceSelector = createSelector(
  AcceptedServicesFeatureSelector,
  (state: any) => state.acceptedServices
);
export const { selectIds, selectEntities, selectAll, selectTotal } = acceptedServicesAdapter.getSelectors(
  acceptedServiceSelector
);
